export const Marquee = ({ items }) => {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-amber-500/20 bg-card/60 py-4" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 font-mono text-xs uppercase tracking-[0.3em] text-amber-400/90">
            {item}
            <span className="inline-block h-1.5 w-1.5 rotate-45 bg-amber-500/70" />
          </span>
        ))}
      </div>
    </div>
  );
};
